import { render } from "./CourseOssPanel.vue?vue&type=template&id=08bec586&scoped=true"
import script from "./CourseOssPanel.vue?vue&type=script&lang=js"
export * from "./CourseOssPanel.vue?vue&type=script&lang=js"

import "./CourseOssPanel.vue?vue&type=style&index=0&id=08bec586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bec586"]])

export default __exports__